exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".st0[data-v-15788d64]{fill:#fff}.st1[data-v-15788d64]{fill:url(#Nieuwe_verloopstaal_11)}.st2[data-v-15788d64]{fill:#fff}.st3[data-v-15788d64]{fill:#afdff9}.st4[data-v-15788d64]{fill:url(#Nieuwe_verloopstaal_1)}.st5[data-v-15788d64]{fill:#5cb4e6}.st6[data-v-15788d64]{fill:#2c4295}", ""]);

// exports
